import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './app/App';
import { applyHmacToAxiosConfig } from './app/store/hmacUtils';
import 'atropos/css'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

axios.interceptors.request.use((config) => {
  const url = config.url || '';
  if (API_BASE_URL && !url.startsWith(API_BASE_URL)) {
    return config;
  }
  return applyHmacToAxiosConfig(config);
});

ReactDOM.render(

  <BrowserRouter>

     <App />

  </BrowserRouter >
  , document.getElementById('root'));







